import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "@pwc-bei/security";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { SAMLJwtCredentials } from "../models/saml-jwt-credentials";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class SamlLoginService {
  readonly apiUrl: string = environment.apiUrl;
  readonly samlUrl: string = environment.samlUrl;
  readonly returnUrl: string = "?returnUrl=" + environment.appUrl + "/auth/sso";

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
  ) { }

  public isAuthenticated(): Observable<boolean> {
    return this.authenticationService.amIAuthenticated();
  }

  /**
   * Make a token request to the saml component
   * @returns an authentication token if the user is
   * already authenticated, or returns an error
   */
  public samlAuthRequest(): Observable<SAMLJwtCredentials> {
    return this.http.get<SAMLJwtCredentials>(`${this.samlUrl}/saml/pwc/entry-point${this.returnUrl}`, {
      withCredentials: true
    });
  }

  /**
   * Exchange the saml token with the access token for the platform
   * @param samlToken
   * @returns an observable signaling authentication success
   */
  public getAccessToken(samlToken: string): Observable<void> {
    return this.authenticationService
      .loginSaml(samlToken)
      .pipe(map(() => { return; }));
  }

}
